import { render, staticRenderFns } from "./Semiconductor.vue?vue&type=template&id=35dd3ab6&"
import script from "./Semiconductor.vue?vue&type=script&lang=js&"
export * from "./Semiconductor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports